import React, { Component } from "react";
import {
  Card,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  FormRadio,
  ButtonIcon,
  Loader,
  FormCheckbox,
  Button,
  Pagination,
} from "ui-kit-ck-consultant";
import {
  faSms,
  faEnvelope,
  faCheckCircle,
  faCheck,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

import { getCurrencyValue } from "../../utils/general";
import axiosConfig from "../../utils/axiosConfig";
import { openEgaLink } from "../../utils/egaLink";

import AuthContext from "../../context/AuthContext";

const SEND_ERRORS = {
  E_PHONE_INVALID: "pas de portable valide",
  E_MAIL_INVALID: "pas de mail valide",
  E_FOLDER_DATA: "données du dossier incomplètes",
  E_SEND_FAILED: "refusé par la passerelle",
  E_LINK: "lien de rendez-vous non créé",
  E_URL_IXPERIENCE_MISSING: "lien ixperience non configuré",
};

export default class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      pageLength: 2000,
      loaderCount: 0,
      loaderTotal: 0,
      dataIdx: {},
      filterGarage: false,
      filterSms: false,
      filterCampingCar: false,
      filterMail: false,
      filterAnswer: false,
      filterCatnat: false,
      filterLevel1: false,
      filterLevel2: false,
      filterLevel3: false,
      order: null,
    };
  }

  static contextType = AuthContext;

  getStatus = (status, key) => {
    switch (status) {
      case 0:
        return (
          <Td key={key} className="pl-10 pr-10 nowrap bg-red-light text-center">
            Anomalie
          </Td>
        );
      case 1:
        return (
          <Td key={key} className="pl-10 pr-10 nowrap bg-red-light text-center">
            En attente de RDV
          </Td>
        );
      case 2:
        return (
          <Td
            key={key}
            className="pl-10 pr-10 nowrap bg-orange-light text-center"
          >
            Expertise à venir
          </Td>
        );
      case 3:
        return (
          <Td
            key={key}
            className="pl-10 pr-10 nowrap bg-blue-light text-center"
          >
            Expertisé
          </Td>
        );
      case 4:
        return (
          <Td
            key={key}
            className="pl-10 pr-10 nowrap bg-green-light text-center"
          >
            Clôturé sans expertise
          </Td>
        );
      case 5:
        return (
          <Td
            key={key}
            className="pl-10 pr-10 nowrap bg-green-light text-center"
          >
            Clôturé avec expertise
          </Td>
        );
      default:
        break;
    }
  };

  // The selection is frozen when the agent confirms: the list may reload while
  // the messages leave.
  sendSelected = async (route, label, data = {}) => {
    const rows = this.props.data.body.filter((row) => this.state.dataIdx[row.id]);
    const refused = [];
    this.setState({ loaderCount: rows.length, loaderTotal: rows.length });

    for (const row of rows) {
      try {
        const res = await axiosConfig(route, {
          data: { folderId: row.id, ...data },
        });
        if (!res.data.success) {
          refused.push(`${row.reference} : ${SEND_ERRORS[res.data.code] || "erreur"}`);
        }
      } catch (error) {
        refused.push(`${row.reference} : erreur serveur`);
      }
      this.setState((state) => ({ loaderCount: state.loaderCount - 1 }));
      await new Promise((resolve) => setTimeout(resolve, 200));
    }

    this.setState({ loaderCount: 0 });
    alert(
      `${label} : ${rows.length - refused.length} envoyé(s) sur ${rows.length}` +
        (refused.length
          ? `\n\nNon envoyés :\n${refused.slice(0, 30).join("\n")}${
              refused.length > 30 ? "\n…" : ""
            }`
          : "")
    );
    this.props.getData();
  };

  sendSmsCatnatManageEGALocation = () =>
    this.sendSelected("EGA/send-sms-catnat-manage-ega-location", "SMS CATNAT");

  sendSmsQuotation = () =>
    this.sendSelected("EGA/send-sms-quotation", "SMS DEVIS REP");

  sendSmsManageEGALocation = () =>
    this.sendSelected("EGA/send-sms-manage-ega-location", "SMS EGA", {
      dataId: Object.keys(this.props.dataId),
    });

  sendMailManageEGALocation = () =>
    this.sendSelected("EGA/send-mail-manage-ega-location", "Mail EGA", {
      dataId: Object.keys(this.props.dataId),
    });

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data)) {
      this.setState({ dataIdx: {} });
    }
  }

  checkExistRegion = (region) => {
    if (this.props.dataLocation && this.props.dataLocation.length) {
      const result = this.props.dataLocation.filter(
        (location) => region === location.region && location.status
      );
      return !!result.length;
    } else {
      return false;
    }
  };

  // The ui-kit Th keeps its own arrow and takes no ref: the column's key
  // comes from the header itself.
  handleSortClick = (name, desc) => {
    this.setState({ order: { name, desc } });
  };

  checkIfIncludes = (model) => {
    const models = [
      "DUCATO",
      "SPRINTER",
      "DAILY",
      "MASTER",
      "JUMPER",
      "BOXER",
      "CALIFORNIA",
      "MULTIVAN",
      "TRANSPORTER",
      "CRAFTER",
    ];

    if (!model) {
      return true;
    } else {
      return !models.filter((element) => model.includes(element)).length;
    }
  };

  render() {
    let dataBody = this.props.data.body.filter(
      (element) =>
        ([0, 1, 2].includes(element.status) &&
          (element.countSmsCatnat === 0 || !this.state.filterCatnat) &&
          (!element.garageName || !this.state.filterGarage) &&
          (element.countSms === 0 || !this.state.filterSms) &&
          (this.checkIfIncludes(element.model) ||
            !this.state.filterCampingCar) &&
          (element.countMail === 0 || !this.state.filterMail) &&
          (!element.egaDateAppointment || !this.state.filterAnswer) &&
          ((parseInt(element.list5Rubrique3) === 1 &&
            this.state.filterLevel1) ||
            (parseInt(element.list5Rubrique3) === 2 &&
              this.state.filterLevel2) ||
            (parseInt(element.list5Rubrique3) === 3 &&
              this.state.filterLevel3) ||
            (!this.state.filterLevel1 &&
              !this.state.filterLevel2 &&
              !this.state.filterLevel3))) ||
        !this.props.isSms
    );

    if (this.state.order) {
      dataBody.sort((a, b) => {
        let aX = a[this.state.order.name] || "";
        let bX = b[this.state.order.name] || "";

        if (Number.isInteger(aX) && Number.isInteger(bX)) {
          return this.state.order.desc ? aX - bX : bX - aX;
        } else {
          aX = aX.toString();
          bX = bX.toString();
          return this.state.order.desc
            ? aX.normalize().localeCompare(bX.normalize())
            : bX.normalize().localeCompare(aX.normalize());
        }
      });
    }

    return (
      <>
        <Card
          title={`Liste des dossiers (${dataBody.length} dossiers)${
            Object.keys(this.state.dataIdx).length
              ? ` (${Object.keys(this.state.dataIdx).length} sélectionnés)`
              : ""
          }`}
          className="mb-10 mb-20-xl"
          classNameChildren="overflow-x-auto"
          action={
            <div className="nowrap w-100 d-flex">
              {this.props.isSms ? (
                <ButtonIcon
                  className="mr-10 bg-green"
                  isBackground
                  onClick={() => {
                    let dataIdx = {};
                    dataBody.forEach((element) => {
                      dataIdx[element.id] = true;
                    });
                    this.setState({ dataIdx });
                  }}
                >
                  <FontAwesomeIcon icon={faCheckCircle} />
                </ButtonIcon>
              ) : null}
              {this.props.isSms ? (
                <ButtonIcon
                  className="mr-10 bg-red"
                  isBackground
                  onClick={() => {
                    let dataIdx = {};
                    this.props.data.body.forEach((element, idx) => {
                      if ([0, 1, 2].includes(element.status)) {
                        delete dataIdx[element.id];
                      }
                    });
                    this.setState({ dataIdx });
                  }}
                >
                  <FontAwesomeIcon icon={faCheckCircle} />
                </ButtonIcon>
              ) : null}
              {this.props.isSms ? (
                <ButtonIcon
                  className="mr-10"
                  disabled={
                    !Object.keys(this.props.dataId).length ||
                    !Object.keys(this.state.dataIdx).filter(
                      (idx) => this.state.dataIdx[idx]
                    ).length
                  }
                  isBackground
                  onClick={() =>
                    window.confirm(
                      "Confirmez vous l'envoi de sms dans tous les dossiers sélectionnés pour toutes les plateformes actives ?"
                    )
                      ? this.sendSmsManageEGALocation()
                      : null
                  }
                >
                  <FontAwesomeIcon icon={faSms} />
                </ButtonIcon>
              ) : null}
              {this.props.isSms ? (
                <ButtonIcon
                  className="mr-10"
                  disabled={
                    !Object.keys(this.props.dataId).length ||
                    !Object.keys(this.state.dataIdx).filter(
                      (idx) => this.state.dataIdx[idx]
                    ).length
                  }
                  isBackground
                  onClick={() =>
                    window.confirm(
                      "Confirmez vous l'envoi de mail dans tous les dossiers sélectionnés pour toutes les plateformes actives ?"
                    )
                      ? this.sendMailManageEGALocation()
                      : null
                  }
                >
                  <FontAwesomeIcon icon={faEnvelope} />
                </ButtonIcon>
              ) : null}
              {this.props.isSms ? (
                <Button
                  className="w-auto mr-10"
                  text="SMS DEVIS REP"
                  disabled={
                    !Object.keys(this.state.dataIdx).filter(
                      (idx) => this.state.dataIdx[idx]
                    ).length
                  }
                  onClick={() =>
                    window.confirm(
                      "Confirmez vous l'envoi de sms DEVIS REP dans tous les dossiers sélectionnés pour toutes les plateformes actives ?"
                    )
                      ? this.sendSmsQuotation()
                      : null
                  }
                >
                  <FontAwesomeIcon icon={faSms} />
                </Button>
              ) : null}
              {this.props.isSms ? (
                <Button
                  className="w-auto mr-10"
                  text="SMS CATNAT"
                  disabled={
                    !Object.keys(this.state.dataIdx).filter(
                      (idx) => this.state.dataIdx[idx]
                    ).length
                  }
                  onClick={() =>
                    window.confirm(
                      "Confirmez vous l'envoi de sms CATNAT dans tous les dossiers sélectionnés pour toutes les plateformes actives ?"
                    )
                      ? this.sendSmsCatnatManageEGALocation()
                      : null
                  }
                >
                  <FontAwesomeIcon icon={faSms} />
                </Button>
              ) : null}
            </div>
          }
          disableStyleAction
        >
          {!this.props.isSms ? (
            <>
              <div className="d-flex mb-10">
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderType === "all" ? true : false}
                  name={"folderType"}
                  text={"Tous"}
                  value={"all"}
                  onChange={this.props.handleInputChange}
                />
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderType === "R" ? true : false}
                  name={"folderType"}
                  text={"Réparables"}
                  value={"R"}
                  onChange={this.props.handleInputChange}
                />
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderType === "NR" ? true : false}
                  name={"folderType"}
                  text={"Non réparables"}
                  value={"NR"}
                  onChange={this.props.handleInputChange}
                />
              </div>
              <div className="d-flex mb-10">
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderStatus === "all" ? true : false}
                  name={"folderStatus"}
                  text={"Tous"}
                  value={"all"}
                  onChange={this.props.handleInputChange}
                />
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderStatus === "new" ? true : false}
                  name={"folderStatus"}
                  text={"En attente de RDV"}
                  value={"new"}
                  onChange={this.props.handleInputChange}
                />
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderStatus === "visit" ? true : false}
                  name={"folderStatus"}
                  text={"Expertise à venir"}
                  value={"visit"}
                  onChange={this.props.handleInputChange}
                />
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderStatus === "visitOK" ? true : false}
                  name={"folderStatus"}
                  text={"Expertisé"}
                  value={"visitOK"}
                  onChange={this.props.handleInputChange}
                />
                <FormRadio
                  className="mr-10"
                  checked={
                    this.props.folderStatus === "noVisited" ? true : false
                  }
                  name={"folderStatus"}
                  text={"Clôturé sans expertise"}
                  value={"noVisited"}
                  onChange={this.props.handleInputChange}
                />
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderStatus === "closing" ? true : false}
                  name={"folderStatus"}
                  text={"Clôturé avec expertise"}
                  value={"closing"}
                  onChange={this.props.handleInputChange}
                />
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderStatus === "error" ? true : false}
                  name={"folderStatus"}
                  text={"Anomalie"}
                  value={"error"}
                  onChange={this.props.handleInputChange}
                />
              </div>
            </>
          ) : (
            <>
              <div className="d-flex mb-10">
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderStatus === "all" ? true : false}
                  name={"folderStatus"}
                  text={"Tous"}
                  value={"all"}
                  onChange={this.props.handleInputChange}
                />
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderStatus === "new" ? true : false}
                  name={"folderStatus"}
                  text={"En attente de RDV"}
                  value={"new"}
                  onChange={this.props.handleInputChange}
                />
                <FormRadio
                  className="mr-10"
                  checked={this.props.folderStatus === "visit" ? true : false}
                  name={"folderStatus"}
                  text={"Expertise à venir"}
                  value={"visit"}
                  onChange={this.props.handleInputChange}
                />
              </div>
              <div className="d-flex mb-10">
                <FormCheckbox
                  text={"Filtre no réparateur"}
                  className="mr-10"
                  checked={this.state.filterGarage}
                  onChange={({ target }) =>
                    this.setState({ filterGarage: target.checked })
                  }
                />
                <FormCheckbox
                  text={"Filtre no SMS"}
                  className="mr-10"
                  checked={this.state.filterSms}
                  onChange={({ target }) =>
                    this.setState({ filterSms: target.checked })
                  }
                />
                <FormCheckbox
                  text={"Filtre no Mail"}
                  className="mr-10"
                  checked={this.state.filterMail}
                  onChange={({ target }) =>
                    this.setState({ filterMail: target.checked })
                  }
                />
                <FormCheckbox
                  text={"Filtre no CAMPING-CAR"}
                  className="mr-10"
                  checked={this.state.filterCampingCar}
                  onChange={({ target }) =>
                    this.setState({ filterCampingCar: target.checked })
                  }
                />
                <FormCheckbox
                  text={"Filtre no Réponse"}
                  className="mr-10"
                  checked={this.state.filterAnswer}
                  onChange={({ target }) =>
                    this.setState({ filterAnswer: target.checked })
                  }
                />
                <FormCheckbox
                  text={"Filtre no CATNAT"}
                  className="mr-10"
                  checked={this.state.filterCatnat}
                  onChange={({ target }) =>
                    this.setState({ filterCatnat: target.checked })
                  }
                />
                <FormCheckbox
                  text={"Filtre niveau 1"}
                  className="mr-10"
                  checked={this.state.filterLevel1}
                  onChange={({ target }) =>
                    this.setState({ filterLevel1: target.checked })
                  }
                />
                <FormCheckbox
                  text={"Filtre niveau 2"}
                  className="mr-10"
                  checked={this.state.filterLevel2}
                  onChange={({ target }) =>
                    this.setState({ filterLevel2: target.checked })
                  }
                />
                <FormCheckbox
                  text={"Filtre niveau 3"}
                  className="mr-10"
                  checked={this.state.filterLevel3}
                  onChange={({ target }) =>
                    this.setState({ filterLevel3: target.checked })
                  }
                />
              </div>
            </>
          )}
          <Table
            isCSV
            getAllData={(callback) =>
              this.setState(
                { pageLength: dataBody.length, activePage: 1 },
                callback
              )
            }
            csvCallback={() => this.setState({ pageLength: 2000 })}
          >
            <Thead>
              <Tr>
                {this.props.data &&
                this.props.data.head &&
                this.props.data.head.length ? (
                  <>
                    {this.props.data.head.map((element, idx) => {
                      return (
                        <Th
                          className="pl-10 pr-10"
                          key={idx}
                          sort={true}
                          onSort={(desc) => this.handleSortClick(element.key, desc)}
                        >
                          {element.name}
                        </Th>
                      );
                    })}
                    {this.props.isSms ? (
                      <>
                        <Th
                          className="pl-10 pr-10"
                          sort={true}
                          onSort={(desc) => this.handleSortClick("egaDateAppointment", desc)}
                        >
                          Réponse
                        </Th>
                        <Th
                          className="pl-10 pr-10"
                          sort={true}
                          onSort={(desc) => this.handleSortClick("countSmsCatnat", desc)}
                        >
                          SMS CAT.
                        </Th>
                        <Th
                          className="pl-10 pr-10"
                          sort={true}
                          onSort={(desc) => this.handleSortClick("countSmsQuotation", desc)}
                        >
                          SMS DEVIS
                        </Th>
                        <Th
                          className="pl-10 pr-10"
                          sort={true}
                          onSort={(desc) => this.handleSortClick("countSms", desc)}
                        >
                          SMS
                        </Th>
                        <Th
                          className="pl-10 pr-10"
                          sort={true}
                          onSort={(desc) => this.handleSortClick("countMail", desc)}
                        >
                          Mail
                        </Th>
                        <Th className="pl-10 pr-10">Actions</Th>
                      </>
                    ) : null}
                  </>
                ) : (
                  <></>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {dataBody
                .slice(
                  (this.state.activePage - 1) * this.state.pageLength,
                  this.state.activePage * this.state.pageLength
                )
                .map((element, idx) => (
                  <Tr key={idx}>
                    {this.props.data.head.map((subElement, subIdx) => {
                      if (subElement.type === "currency") {
                        return (
                          <Td className="pl-10 pr-10" key={subIdx}>
                            {element[subElement.key]
                              ? getCurrencyValue(element[subElement.key])
                              : ""}
                          </Td>
                        );
                      } else if (subElement.type === "date") {
                        return (
                          <Td className="pl-10 pr-10" key={subIdx}>
                            {element[subElement.key]
                              ? moment(element[subElement.key]).format(
                                  "DD/MM/YYYY"
                                )
                              : ""}
                          </Td>
                        );
                      } else if (subElement.type === "status") {
                        return this.getStatus(element[subElement.key], subIdx);
                      } else if (subElement.type === "truefalse") {
                        return (
                          <Td key={subIdx}>{element[subElement.key] ? "Oui" : "Non"}</Td>
                        );
                      } else {
                        return (
                          <Td className="pl-10 pr-10" key={subIdx}>
                            {element[subElement.key]}
                          </Td>
                        );
                      }
                    })}
                    {this.props.isSms ? (
                      <>
                        <Td className="pl-10 pr-10">
                          {element.egaDateAppointment
                            ? `OUI ${element.egaDateAppointment} à ${element.egaHourAppointment}`
                            : "NON"}
                        </Td>
                        <Td className="pl-10 pr-10">
                          {element.countSmsCatnat}
                        </Td>
                        <Td className="pl-10 pr-10">
                          {element.countSmsQuotation}
                        </Td>
                        <Td className="pl-10 pr-10">{element.countSms}</Td>
                        <Td className="pl-10 pr-10">{element.countMail}</Td>
                        <Td className="pl-10 pr-10">
                          <div className="d-flex">
                            {(element.phone || element.mail) &&
                            this.checkExistRegion(element.region) &&
                            !element.egaDateAppointment ? (
                              <FormCheckbox
                                className="m-auto ml-0"
                                checked={
                                  this.state.dataIdx[element.id]
                                    ? this.state.dataIdx[element.id]
                                    : false
                                }
                                onChange={({ target }) => {
                                  let dataIdx = this.state.dataIdx;
                                  if (target.checked) {
                                    dataIdx[element.id] = target.checked;
                                  } else {
                                    delete dataIdx[element.id];
                                  }
                                  this.setState({ dataIdx });
                                }}
                              />
                            ) : null}
                            <ButtonIcon
                              className="blue"
                              small
                              onClick={() => openEgaLink(element.id)}
                            >
                              <FontAwesomeIcon icon={faCheck} />
                            </ButtonIcon>
                          </div>
                        </Td>
                      </>
                    ) : null}
                  </Tr>
                ))}
            </Tbody>
          </Table>
          <Pagination
            activePage={this.state.activePage}
            itemsCountPerPage={this.state.pageLength}
            totalItemsCount={dataBody.length}
            pageRangeDisplayed={4}
            onChange={(activePage) => {
              this.setState({ activePage: activePage });
            }}
            firstPageText={<FontAwesomeIcon icon={faAngleDoubleLeft} />}
            lastPageText={<FontAwesomeIcon icon={faAngleDoubleRight} />}
            prevPageText={<FontAwesomeIcon icon={faChevronLeft} />}
            nextPageText={<FontAwesomeIcon icon={faChevronRight} />}
          />
        </Card>
        <Loader
          show={this.state.loaderCount > 0}
          message={`${this.state.loaderTotal - this.state.loaderCount}/${
            this.state.loaderTotal
          }`}
        />
      </>
    );
  }
}
